import React from 'react'
import { withRouter } from "react-router-dom"
import i18n from '../../../i18n'
import { sidebar, screens } from '../screen'
import { initGA, logPageView, trackingEvent } from "./GoogleAnalytics.js"
import {connect} from "react-redux"
import {mapDispatchToProps} from "../../mapDispatchToProps"

export class Sidebar extends React.Component {
  componentDidMount() {
    this.activeScreen(this.props.location.pathname)
  }

  activeScreen(path) {
    let pathname = path.slice(1)
    this.props.screenActions.setScreenInfo(screens[pathname.replace(/-/g, '_')])
  }

  trackingBankLink(menu) {
    this.pageView()
    this.props.history.push(menu.to)
    this.activeScreen(menu.to)
    switch(this.props.location.pathname) {
      case '/bank':
        trackingEvent("Bank", "メニュー")
        break;
      case '/application':
        trackingEvent("Application", "メニュー")
        break;
      case '/csv':
        trackingEvent("CSV", "メニュー")
        break;
      case '/tags':
        trackingEvent("Tag", "メニュー")
        break;
      case '/account':
        trackingEvent("Office", "メニュー")
        break;
      case '/transaction':
        trackingEvent("History", "メニュー")
        break;
      default:
        break;
    }
  }

  pageView () {
    if (!window.GA_INITIALIZED) {
      initGA()
      window.GA_INITIALIZED = true
    }
    logPageView()
  }

  render() {
    const privacyLink = "https://corp.moneyforward.com/privacy/#treatment"
    const aggrementLink = "https://biz.moneyforward.com/agreement"
    const externalToolsLink = "https://corp.moneyforward.com/privacy/external-tools/"

    return (
      <nav className="col-sm-2 sidebar">
        <ul>
          {Object.values(sidebar).map(menu => {
            const active = this.props.location.pathname === menu.to ? 'active' : '';
            return (
              <li key={menu.key} className={`nav-item  ${menu.icon} ${active}`} onClick={() => this.trackingBankLink(menu)}>
                <button className={`d-flex align-items-center btn-link normal nav-link ${active}`}>
                  <span>{menu.name}</span>
                </button>
              </li>
            );
          })}
        </ul>

        <div className="sidebar-footer fixed-bottom">
          <ul>
            <li>
              <a target="_blank" href={aggrementLink} rel="noopener noreferrer">{i18n.t('sidebar.terms')}</a>
            </li>
            <li>
              <button className="btn-link" onClick={() => {this.pageView(); this.props.history.push('/terms-of-use')}}>{i18n.t('sidebar.terms_of_use')}</button>
            </li>
            <li>
              <a target="_blank" href={privacyLink} rel="noopener noreferrer">{i18n.t('sidebar.privacy')}</a>
            </li>
            <li className="external-tools">
              <a target="_blank" href={externalToolsLink} rel="noopener noreferrer">{i18n.t('sidebar.external_tools')}</a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));
